<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container"> 
    <!-- ============================================================== -->
    <!-- Topbar - style you can find in header.scss -->
    <!-- ============================================================== -->
    <mat-toolbar #toolbar class="topbar topbar-sticky" [ngClass]="{'toolbar-condensed':toolbarCondensed}">
        <!-- ============================================================== -->
        <!-- Logo - style you can find in header.scss -->
        <!-- ============================================================== -->
        <div class="container-fluid d-flex full-height">
            
        <div class="navbar-header">
            <!-- [routerLink]="[ './', 'dashboard' ]" -->
            <a class="navbar-brand d-flex align-items-center fh" >
                <!-- Logo icon -->
                    <!-- Dark Logo icon -->
                    <ng-container *ngIf="lightMode; else darkMode">
                        <img [ngSrc]="logoPath" width="36" height="36" alt="homepage" class="dark-logo logo--brand" priority>
                    </ng-container>
                    <ng-template #darkMode>
                        <!-- Light Logo icon -->
                        <img [ngSrc]="logoDarkPath" width="36" height="36" alt="homepage" class="light-logo logo--brand" priority>
                    </ng-template>
                <!-- Logo text -->
                <span class="text-logo-icon" fxShow="false" fxShow.gt-xs>
                 <!-- site brand name -->
                 <span class="site-brand-name">{{ commonConfig.getSiteName() }}</span>
                </span> </a>
        </div>
        <div class="flex-fill d-flex align-items-center justify-content-end">
             <app-header class="d-flex align-items-center justify-content-end flex-fill full-height" *ngIf="mobileQuery.matches">
                 <ngx-shopping-cart beforeSecondaryMenu></ngx-shopping-cart>
             </app-header>
             <ng-container *ngIf="!mobileQuery.matches">
                 <ngx-shopping-cart ></ngx-shopping-cart>
             <button  mat-icon-button
                    (click)="togglesidenav()">
                <mat-icon>menu</mat-icon>
            </button>
             </ng-container>
            
        </div>
        <!-- ============================================================== -->
        <!-- app header component - style you can find in header.scss / header.component.ts-->
        <!-- ============================================================== -->
        
       

        <!-- ============================================================== -->
        <!-- sidebar toggle -->
        <!-- ============================================================== -->
        <!-- <ng-container *ngIf="!mobileQuery.matches">
            <div class="flex-fill d-flex align-items-center justify-content-end">
                <ngx-shopping-cart *ngIf="layoutABtest == 'a'"></ngx-shopping-cart>
             
                <button  mat-icon-button 
                (click)="togglesidenav()">
            <mat-icon>menu</mat-icon>
        </button></div>
        </ng-container> -->
       
        
        </div>
    </mat-toolbar>
    <ng-container *ngIf="mobileQuery.matches; else mobileLayout ">
        <ng-container *ngTemplateOutlet="desktopLayout"></ng-container>
    </ng-container>
</div>
<div class="sub-footer-container">
    
    <!-- <web-solveup-component [person]="person" (loadComp)="onComponentLoad($event)" [statictoken]="staticToken"></web-solveup-component> -->
    <ngx-assistance-form 
    [buttonIcon]="true"
    [buttonMessage]="false"
    [buttonPosition]="'bottom'"
    [formEnter]="'bottom'"
    [adapter]="assistanceFormAdapterImplementationService" 
    [recaptchaSiteKey]="recaptchaSiteKey"
    [person]="person"
    [statictoken]="staticToken"
    #assistanceForm
    ></ngx-assistance-form>
</div>

<ng-template #mobileLayout>
     <!-- ============================================================== -->
    <!-- End Topbar - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-container class="main-sidenav-container"  [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        <mat-sidenav #snav id="snav" class="dark-sidebar pl-xs" 
        [class.hide]="mobileQuery.matches"
        position="end"
        [mode]="mobileQuery.matches ? 'side' : 'over'"
        fixedInVewport="true"
        fixedTopGap="0"
        [disableClose]="mobileQuery.matches"  
        (click)="togglesidenav()"
        [opened]="sidenavOpen"
        >
        
        <app-header class="d-flex flex-column fw" ></app-header>
                <!-- <app-sidebar></app-sidebar> -->
        </mat-sidenav>
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
        <mat-sidenav-content class="page-wrapper d-flex flex-column">
                 
                <div class="page-wrapper-content flex-1" >
                   
                        <router-outlet></router-outlet>
                    
                </div>
                <div class="footer-container pt--12 footer-bg">
                    <app-footer></app-footer>
                </div>    
               
        </mat-sidenav-content>
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
    </mat-sidenav-container>
</ng-template>
<ng-template #desktopLayout>
    <section class="page-wrapper flex-fill">
        <div class="page-wrapper-content">
            <router-outlet></router-outlet>
        </div>
    </section>
    <div class="footer-container pt--24 footer-bg">
        <app-footer></app-footer>
    </div>
    
</ng-template>